"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _immutable = require("immutable");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _CompanyRecord = _interopRequireDefault(require("customer-data-objects/company/CompanyRecord"));

var _ContactRecord = _interopRequireDefault(require("customer-data-objects/contact/ContactRecord"));

var _DealRecord = _interopRequireDefault(require("customer-data-objects/deal/DealRecord"));

var _TicketRecord = _interopRequireDefault(require("customer-data-objects/ticket/TicketRecord"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _logTimelineMountTiming = _interopRequireDefault(require("crm_ui/utils/logTimelineMountTiming"));

var TimelineEvent =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineEvent, _PureComponent);

  function TimelineEvent() {
    (0, _classCallCheck2.default)(this, TimelineEvent);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineEvent).apply(this, arguments));
  }

  (0, _createClass2.default)(TimelineEvent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _logTimelineMountTiming.default)(this.props.dataStartTime, this.props.profileStartTime);
    }
  }, {
    key: "getEmail",
    value: function getEmail() {
      var _this$props = this.props,
          subject = _this$props.subject,
          objectType = _this$props.objectType;

      if (subject && objectType === _ObjectTypes.CONTACT) {
        return (0, _ImmutableModel.getProperty)(subject, 'email');
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          objectType = _this$props2.objectType,
          subject = _this$props2.subject,
          subjectId = _this$props2.subjectId,
          timelineItem = _this$props2.timelineItem,
          TimelineComponent = _this$props2.TimelineComponent,
          ChildComponent = _this$props2.ChildComponent;

      if (!timelineItem || !TimelineComponent) {
        return null;
      }

      return _react.default.createElement(TimelineComponent, {
        email: this.getEmail(),
        objectType: objectType,
        subject: subject,
        subjectId: subjectId,
        timelineItem: timelineItem,
        TimelineEvent: ChildComponent
      });
    }
  }]);
  return TimelineEvent;
}(_PureComponent2.default);

TimelineEvent.propTypes = {
  ChildComponent: _propTypes.default.func,
  dataStartTime: _propTypes.default.number,
  objectType: _ObjectTypesType.default.isRequired,
  profileStartTime: _propTypes.default.number,
  subject: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_CompanyRecord.default).isRequired, _propTypes.default.instanceOf(_ContactRecord.default).isRequired, _propTypes.default.instanceOf(_DealRecord.default).isRequired, _propTypes.default.instanceOf(_TicketRecord.default).isRequired]),
  subjectId: _propTypes.default.string.isRequired,
  timelineItem: _propTypes.default.instanceOf(_immutable.Map).isRequired,
  TimelineComponent: _propTypes.default.func
};
var _default = TimelineEvent;
exports.default = _default;
module.exports = exports.default;